import Vue from 'vue'
import Router from 'vue-router'
import FileUpload from '@/views/fileUpload/index.vue'
import FileManage from '@/views/fileManage/index.vue'
import PorjectDetail from '@/views/fileManage/projectDetail.vue'
import AppUpload from '@/views/appUpload/index.vue'
import StaticPage from '@/views/staticPage/index.vue'
import AddStaticPage from '@/views/staticPage/addStaticPage.vue'
import Project from '@/views/xpsCdn/project.vue'
import Version from '@/views/xpsCdn/version.vue'
import MyFiles from '@/views/myFiles/index.vue'
import HtmlPage from '@/views/staticPage/htmlPage'
import err401Page from "@/views/errorPage/401.vue";
import err404Page from "@/views/errorPage/404.vue";


// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
        path: '/',
        redirect: '/fileUpload', //设置默认指向的路径
        name: '主页'
    },
    {
        path: '/fileUpload',
        name: 'fileUpload',
        component: FileUpload
    },
    {
        path: '/fileManage',
        name: 'fileManage',
        component: FileManage
    },
    {
        path: '/fileManage/projectDetail',
        name: 'projectDetail',
        component: PorjectDetail
    },
    {
        path: '/appUpload',
        name: 'appUpload',
        component: AppUpload
    },
    {
        path: '/staticPage',
        name: "staticPage",
        component: StaticPage,
    },
    {
        path: "/staticPage/addStaticPage",
        name: 'addStaticPage',
        component: AddStaticPage
    },
    {
        path: '/htmlPage',
        name: "htmlPage",
        component: HtmlPage,
    },
    {
        path: '/xpsCdn',
        name: 'project',
        component: Project,
    },
    {
        path: '/xpsCdn/version',
        name: 'version',
        component: Version,
    },
    {
        path: '/myFiles',
        name: 'myFiles',
        component: MyFiles,
    },
    {
        path: "/404",
        component: err404Page,
    },
    {
        path: "/401",
        component: err401Page
    },
    {
        path: "*",
        redirect: "/404"
    }
    ]
})